import React, { useContext } from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
import SimpleHeader from "../components/SimpleHeader";
import NewsContainer from "../components/NewsContainer";
import { LanguageContext } from "../languages/LanguageContext";
import FacebookAd from "../components/FacebookAd";
import PageTitle from "../components/PageTitle";

const News = () => {
    const { language, translations } = useContext(LanguageContext);
    return (
        <>
            <PageTitle title='News' />
            <Header />
            <div className='main-container'>
                <SimpleHeader
                    title={"news"}
                    route={"news"}
                    url={"news"}
                />
                <FacebookAd />
                <div className='news-wrap flex'>
                    <NewsContainer
                        title={translations[language]["newsTitle13"]}
                        date={translations[language]["newsDate13"]}
                        content={translations[language]["newsContent13"]}
                        addon={'https://www.facebook.com/100007484534600/posts/2295453290714133/'}
                    />
                    <NewsContainer
                        title={translations[language]["newsTitle12"]}
                        date={translations[language]["newsDate12"]}
                        content={translations[language]["newsContent12"]}
                        addon={'https://facebook.com/media/set/?set=a.840617669627124&type=3'}
                    />
                    <NewsContainer
                        title={translations[language]["newsTitle11"]}
                        date={translations[language]["newsDate11"]}
                        content={translations[language]["newsContent11"]}
                    />
                    <NewsContainer
                        imageCount={16}
                        prefix='news16-'
                        folder={'news/international-conference-smiltene-2018/'}
                        title={translations[language]["newsTitle1"]}
                        date={translations[language]["newsDate1"]}
                        content={translations[language]["newsContent1"]}
                    />
                    <NewsContainer
                        imageCount={13}
                        prefix='news14-'
                        suffix='big'
                        folder={'news/volksfest-kelme/'}
                        title={translations[language]["newsTitle14"]}
                        date={translations[language]["newsDate14"]}
                        content={translations[language]["newsContent14"]}
                    />
                    <NewsContainer
                        imageCount={60}
                        prefix='news15-'
                        suffix='big'
                        folder={'news/concluding-conference-in-zespol/'}
                        title={translations[language]["newsTitle2"]}
                        date={translations[language]["newsDate2"]}
                        content={translations[language]["newsContent2"]}
                        addon={'http://www.zs2ndg.szkolnastrona.pl/art,943,podsumowanie-stazy-zagranicznych-projektu-erasmus-warszawska-na-stazach-w-europie-w-zespole-szkol-nr2-w-nowym-dworze-gd'}
                    />
                    <NewsContainer
                        imageCount={64}
                        prefix='news13-'
                        suffix='big'
                        folder={'news/art-festival-xxxvii/'}
                        title={translations[language]["newsTitle3"]}
                        date={translations[language]["newsDate3"]}
                        content={translations[language]["newsContent3"]}
                        addon={'http://www.kelme.lt/5'}
                    />
                    <NewsContainer
                        imageCount={24}
                        prefix='tschechien-'
                        folder={'news/closing-conference-in-lipa/'}
                        title={translations[language]["newsTitle4"]}
                        date={translations[language]["newsDate4"]}
                        content={translations[language]["newsContent4"]}
                    />
                    <NewsContainer
                        imageCount={2}
                        prefix='news11-'
                        folder={'news/closing-conference-in-krosno/'}
                        title={translations[language]["newsTitle5"]}
                        date={translations[language]["newsDate5"]}
                        content={translations[language]["newsContent5"]}
                    />
                    <NewsContainer
                        imageCount={34}
                        prefix='news10-'
                        folder={'news/office-opening/'}
                        title={translations[language]["newsTitle6"]}
                    />
                    <NewsContainer
                        imageCount={5}
                        prefix='news9-'
                        folder={'news/erasmus-achievements-2014/'}
                        title={translations[language]["newsTitle7"]}
                        date={translations[language]["newsDate7"]}
                    />
                    <NewsContainer
                        imageCount={35}
                        prefix='malta-'
                        folder={'news/project-in-malta/'}
                        title={translations[language]["newsTitle8"]}
                        content={translations[language]["newsContent8"]}
                    />
                    <NewsContainer
                        folder={'news/colleagues-from-utena-rpmc/'}
                        imageCount={40}
                        prefix='litauen'
                        title={translations[language]["newsTitle9"]}
                        content={translations[language]["newsContent9"]}
                    />
                    <NewsContainer
                        folder={'news/final-conference-in-lithuania/'}
                        imageCount={2}
                        prefix='news01-'
                        title={translations[language]["newsTitle10"]}
                        content={translations[language]["newsContent10"]}
                        date={translations[language]["newsDate10"]}
                    />
                </div>
            </div>
            <Footer />
        </>
    );
};

export default News;